import type { PriceUnitType } from '@/api';
import { CalculationType, RmCalculationType, RrpCalculationType } from '@/api';
export type { PriceUnitType } from '@/api';

export type MenuItem = {
  value: string;
  label?: string;
};

export type PriceUnitCalculationSettings = {
  id: number;
  priceUnitId: string;
  priceUnitName: string;
  priceUnitType: PriceUnitType;
  year: string;
  calculationType?: CalculationType;
  calculationBasisValue?: string;
  autoCalcEnabled: boolean;
  breakEvenFactor?: string;
  targetRrpIndex?: string;
  lpFmcTarget: string;
  targetLpIndex: string;
  aboveThresholdMax: string;
  aboveThresholdMin: string;
  belowThresholdMax: string;
  belowThresholdMin: string;
  threshold: string;
  rmPercentage?: RmCalculationType;
  rrpType?: RrpCalculationType;
};

export type PriceUnitSettingsTouchedField = keyof Pick<
  PriceUnitCalculationSettings,
  | 'calculationType'
  | 'rmPercentage'
  | 'rrpType'
  | 'breakEvenFactor'
  | 'targetRrpIndex'
  | 'targetLpIndex'
  | 'lpFmcTarget'
  | 'threshold'
  | 'aboveThresholdMin'
  | 'aboveThresholdMax'
  | 'belowThresholdMin'
  | 'belowThresholdMax'
>;

export type ThresholdSettingsTouchedField = keyof Pick<
  PriceUnitCalculationSettings,
  | 'aboveThresholdMin'
  | 'aboveThresholdMax'
  | 'belowThresholdMin'
  | 'belowThresholdMax'
>;

export type CalculationMethodsValidation = {
  isMissingCalculationType: boolean;
  isMissingRm: boolean;
  isMissingRrp: boolean;
  isMissingBreakEven: boolean;
  isMissingTargetRrp: boolean;
};

export type SimulationSettingsValidation = {
  isInvalidTargetLpIndex: boolean;
  isInvalidLpFmcTarget: boolean;
  isInvalidThreshold: boolean;
  isInvalidAboveThreshold: boolean;
  isInvalidBelowThreshold: boolean;
};

export const CALCULATION_TYPE_LABELS: Record<CalculationType, string> = {
  [CalculationType.PredefinedMarketRrpAndFixedLpPricePoints]:
    'Predefined Market RRP & Fixed LP price points',
  [CalculationType.LpOnly]: 'LP only (Distributor)',
  [CalculationType.DirectCurrencyConversion]: 'Direct Currency Conversion',
  [CalculationType.LicensedProducts]: 'Licensed Products',
  [CalculationType.TargetDrivenLpAndRrpCalculatedRm]:
    'Target driven LP & RRP and Calculated RM%',
};

export const RM_CALCULATION_TYPE_LABELS: Record<RmCalculationType, string> = {
  [RmCalculationType.Total]: 'Total',
  [RmCalculationType.PerTierAndTheme]: 'Tier and Theme',
  [RmCalculationType.PerTierAndLicenseMark]: 'Tier and License mark',
  [RmCalculationType.CopyLocalLeadRmToLocalRm]:
    'Copy Local LEAD RM% to Local RM%',
  [RmCalculationType.PerTierAndGroup]: 'Tier and Group',
};

export const RRP_CALCULATION_TYPE_LABELS: Record<RrpCalculationType, string> = {
  [RrpCalculationType.LocalPricePointRounding]: 'Local Price Point Rounding',
  [RrpCalculationType.PredefinedLeadToLocalPp]: 'Predefined LEAD to local PP',
};
